import React, { Component } from 'react';
import { Pie } from './Pie';
//import { select } from 'd3-selection'
import "./styles/Chart.css";

export class Chart extends Component {
    render() {
        let innerWidth = window.innerWidth;
        //let innerHeight = window.innerHeight;
        let width = innerWidth > 550 ? 550 : innerWidth*.9;
        let height = 500; // window.innerHeight/2;
        let minViewportSize = Math.min(width, height);
        // This sets the radius of the pie chart to fit within
        // the current window size, with some additional padding
        let radius = (minViewportSize * .8) / 2;
        // Centers the pie chart
        let x = width / 2;
        let y = height / 2;

        return (
            <div className="panel panel-default chart">
                <div className="panel-header chart-header">
                    <label>{this.props.title}</label>
                </div>
                <div className="panel-body">
                    <svg width="100%" height="100%" className="chart-body">
                        {/* We'll create this component in a minute */}
                        <Pie x={x} y={y} radius={radius}
                            label={this.props.labels}
                            data={this.props.data}
                            dot={this.props.dot} />
                    </svg>
                </div>
            </div>
        );

    }
}

//function wrap(element, width) {
//    var text = select('.wrapme')
//    var words = text.text().split(/\s+/).reverse();
//}


// WEBPACK FOOTER //
// ./src/components/common/Chart.js